<template>
  <div id="app">
    <router-view></router-view>
   </div>
</template>
<script>
export default {  
  data: function() {
    return {}
  }
}
</script>


// WEBPACK FOOTER //
// app.vue?8b6a36fa